<template>
  <div class="mb-5 mt-8">
    <div class="font-bold">{{ t("collaborators.title") }}</div>
    <div class="text-medium-emphasis text-sm">
      {{ t("collaborators.description") }}
    </div>
  </div>
  <v-radio-group
    v-model="mode"
    :disabled="loading"
    color="primary"
    hide-details
    data-testid="collaborators-mode"
  >
    <v-radio :label="t('collaborators.modes.all')" value="all"></v-radio>
    <v-radio :label="t('collaborators.modes.selected')" value="selected"></v-radio>
    <v-radio :label="t('collaborators.modes.none')" value="none"></v-radio>
  </v-radio-group>
  <template v-if="mode === 'selected'">
    <div v-if="!loading && !selected.length" class="text-error text-sm mt-2">
      {{ t("collaborators.selectAtLeastOne") }}
    </div>
    <v-table density="compact" class="mt-4">
      <thead>
        <tr>
          <th class="text-left assigned-column">{{ t("collaborators.assigned") }}</th>
          <th class="text-left">{{ t("collaborators.email") }}</th>
        </tr>
      </thead>
      <v-skeleton-loader v-if="loading" type="table-thead, table-tbody"></v-skeleton-loader>
      <tbody>
        <tr v-for="user in users" :key="user.uid">
          <td class="assigned-column">
            <v-checkbox
              v-model="selected"
              color="primary"
              :value="user.uid"
              hide-details
              density="compact"
            ></v-checkbox>
          </td>
          <td>{{ user.email }}</td>
        </tr>
      </tbody>
    </v-table>
  </template>
</template>

<script setup lang="ts">
import { useI18n } from "@/composables/useI18n";
import type { AssignedSupervisors } from "@aircap/common/account";

const { t } = useI18n();
const selected = defineModel<string[]>({
  required: true,
});
const mode = defineModel<AssignedSupervisors["mode"]>("mode", {
  required: true,
});

defineProps<{
  users: { uid: string; email: string }[];
  loading: boolean;
}>();
</script>

<style scoped>
.assigned-column {
  width: 100px;
  max-width: 100px;
}
</style>
